module.exports = __webpack_public_path__ + "static/img/visual.0ca530a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/promotion/PR010228/visual.png
// module id = F47G
// module chunks = 10